import React, { useState } from "react";
const MenuButton = ({
  id,
  text,
  icon,
  iconOn,
  active,
  onClick,
  disabled,
  message,
  className,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      id={id}
      className={`flex group relative overflow-visible items-center px-3 py-2 rounded ${
        isHovered ? "bg-vb-highlight" : "bg-transparent"
      } ${className || ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      disabled={disabled}
    >
      <img
        src={isHovered ? iconOn : icon}
        alt="Logo"
        className={`${text ? "mr-2" : ""} w-4`}
      />
      {text && text}
      {message && (
        <p className="whitespace-nowrap hidden group-hover:block absolute bottom-full bg-vb-highlight p-2 rounded left-[50%] translate-x-[-50%]">
          {message}
        </p>
      )}
    </button>
  );
};

export default MenuButton;
